import type { ICellRendererComp, ICellRendererParams } from 'ag-grid-community';

export class SkeletonCellRenderer implements ICellRendererComp {
  private eGui!: HTMLElement;

  public init(params: ICellRendererParams) {
    this.eGui = document.createElement('div');
    this.updateContents(params);
  }

  public getGui() {
    return this.eGui;
  }

  public refresh(params: ICellRendererParams) {
    this.updateContents(params);
    return true;
  }

  private updateContents(params: ICellRendererParams): void {
    const colId = params.colDef?.colId;
    const loadingColumns: string[] = params.context?.loadingColumns ?? [];
    const isLoading = colId && loadingColumns.includes(colId);

    if (isLoading) {
      this.eGui.className = 'skeleton-cell';
      this.eGui.innerHTML = '<div class="skeleton-cell-bar"></div>';
    } else {
      this.eGui.className = '';
      this.eGui.textContent = params.valueFormatted ?? params.value ?? '';
    }
  }
}
